var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProciteai = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.59,
    height: 79.19,
    viewBox: "0 0 114.59 79.19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9bc83a;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #40535e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #ffbc20;\n      }\n\n      .cls-4 {\n        fill: #050605;\n      }\n\n      .cls-5 {\n        fill: #f7981d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 59.59,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 24.19,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.59,
    y: 9.5,
    width: 97,
    height: 62,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.76,53c-3.11,0-6.1-1.23-8.3-3.44h0c-4.54-4.58-4.54-11.97,.02-16.54,4.57-4.59,12.01-4.61,16.6-.04l.88-.88c-5.03-4.87-13.02-4.87-18.05,0-5.15,4.99-5.29,13.21-.31,18.36h0c5.07,5.05,13.28,5.05,18.34-.02,0,0,0,0,0,0l-.88-.88c-2.2,2.21-5.19,3.45-8.3,3.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.91,31.95c.08-.09,.11-.21,.11-.34,0-.19-.07-.33-.22-.43s-.36-.15-.65-.15h-.8v2h.55v-.8h.16l.38,.8h.61l-.44-.88c.13-.04,.24-.11,.31-.2Zm-.54-.1c-.06,.04-.15,.06-.27,.06h-.2v-.53h.16c.14,0,.24,.02,.3,.07,.06,.04,.09,.11,.09,.21,0,.09-.03,.15-.09,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.81,31.37c-.09-.22-.21-.41-.38-.58-.17-.18-.37-.32-.6-.41s-.46-.14-.72-.14-.47,.04-.69,.13-.41,.22-.58,.38c-.18,.18-.32,.38-.41,.6-.1,.23-.14,.46-.14,.71s.04,.46,.14,.68c.09,.22,.22,.41,.39,.59,.17,.18,.37,.32,.59,.41,.22,.09,.46,.14,.7,.14s.46-.05,.69-.14c.22-.09,.42-.22,.6-.39,.18-.17,.31-.36,.4-.58s.14-.46,.14-.71-.04-.48-.13-.7Zm-.31,1.28c-.07,.18-.18,.34-.33,.48-.14,.14-.31,.24-.49,.32-.18,.07-.37,.11-.57,.11s-.39-.04-.58-.12-.34-.19-.49-.34c-.14-.14-.25-.3-.32-.47-.07-.18-.11-.36-.11-.56s.04-.4,.12-.58c.08-.18,.19-.35,.33-.5,.14-.14,.3-.24,.48-.31,.18-.07,.37-.11,.57-.11s.4,.04,.58,.11c.18,.08,.35,.19,.49,.34,.14,.14,.24,.3,.31,.47,.07,.18,.11,.37,.11,.57s-.04,.4-.11,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.71,37.43l1.52-1.98c-1.28-.99-2.86-1.52-4.48-1.52-4.05,0-7.33,3.29-7.32,7.34,0,4.05,3.29,7.33,7.34,7.32,1.44,0,2.84-.42,4.04-1.21l-1.38-2.08c-1.72,1.14-3.98,1.06-5.62-.2-2.12-1.63-2.52-4.67-.89-6.79,1.63-2.12,4.67-2.52,6.79-.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.15,
    y: 36.63,
    width: 2.73,
    height: 11.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "49.47 32.82 46.74 32.82 46.74 36.63 45.43 36.63 45.43 39.03 46.74 39.03 46.74 47.99 49.47 47.99 49.47 39.03 51.12 39.03 51.12 36.63 49.47 36.63 49.47 32.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.59,37.91c-2.32-2.26-6.03-2.2-8.29,.11-1.14,1.14-1.77,2.69-1.74,4.3-.03,1.61,.6,3.15,1.73,4.29,1.09,1.15,2.61,1.79,4.2,1.77h0c1.26,.02,2.48-.35,3.51-1.08,1-.7,1.73-1.72,2.07-2.89h-2.88c-.24,.46-.6,.83-1.06,1.07-.48,.27-1.02,.41-1.58,.4-.89,.02-1.74-.35-2.32-1.02-.35-.39-.62-.84-.77-1.34h8.86c.07-.4,.1-.8,.1-1.2,.03-1.61-.6-3.16-1.74-4.3-.04-.04-.08-.08-.11-.11Zm-7.19,3.43c.15-.58,.43-1.12,.82-1.57,.08-.1,.18-.19,.27-.27,1.26-1.11,3.18-.99,4.29,.27,.4,.44,.68,.98,.81,1.57h-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.4,37.88c-1-1.06-2.4-1.66-3.85-1.63-1.53-.02-2.99,.63-4,1.78-1.09,1.16-1.69,2.71-1.65,4.3-.03,1.59,.56,3.13,1.66,4.29,1.01,1.14,2.47,1.78,3.99,1.77h0c1.46,.01,2.85-.57,3.86-1.62v1.24h2.5v-11.37h-2.51v1.25Zm-1.02,7s-.09,.09-.14,.14c-1.32,1.24-3.4,1.18-4.64-.14-.64-.69-.99-1.61-.96-2.55-.03-.95,.32-1.87,.96-2.57,.61-.68,1.48-1.06,2.39-1.04,.91-.02,1.78,.36,2.39,1.03,.64,.7,.99,1.62,.96,2.56,.03,.95-.32,1.87-.97,2.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.05,
    y: 36.63,
    width: 2.73,
    height: 11.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.42,31.12s0,0,0,0c-.78,0-1.42,.64-1.41,1.42s.64,1.42,1.42,1.41c.78,0,1.42-.64,1.41-1.42h0c0-.78-.63-1.41-1.42-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.3,45.22h0c-.78,0-1.42,.64-1.42,1.42,0,.78,.64,1.42,1.42,1.42s1.42-.64,1.42-1.42c0-.78-.63-1.42-1.42-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.93,32.54c0-.78-.64-1.42-1.42-1.42,0,0,0,0,0,0-.78,0-1.42,.64-1.41,1.42,0,.78,.64,1.42,1.42,1.41,.78,0,1.42-.64,1.41-1.42h0s0,0,0,0Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProciteai);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pro.citeai.9b0f2b2933a910cdcd9abfc35280a437.svg";